<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row"
      v-if="userData.permissions['view_loanapplications'] == 1 && userData.permissions['view_loans'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <div class="d-flex justify-content-end">
              <b-alert size="small" show dismissible variant="success">
                <b>Formula &nbsp;</b>
                <hr class="mb-0 mt-1">
                <code>Interest = Loan X (Monthly_Rate/100) X Time_in_months</code>
              </b-alert>
            </div>
            <span class="d-flex justify-content-between mb-2">

              <div class="d-flex justify-content-between">
                <div><label>From</label><input class="form-control" v-model="date_from" type="date">
                </div>
                <div class="mx-1"><label>To</label><input class="form-control" v-model="date_to" type="date"></div>
                <div class="mt-4"><b-button variant="primary" @click="FilterData"><i class="mdi mdi-filter"></i>
                    Filter</b-button></div>
              </div>
              <span v-show="userData.permissions['new_loanapplications'] == 1" class="mt-4">
                <b-button @click.prevent="$bvModal.show('new-application'); clearFields();" variant="primary" type="button" class="btn-sm btn"> <i class="mdi mdi-plus"></i> New Application</b-button>
              </span>
            </span>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-4">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                      :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-4">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <b-table :items="Items" :fields="Fields" responsive="sm" :per-page="perPage" :current-page="currentPage"
                :filter="filter" :filter-included-fields="filterOn" @filtered="Filtered" :busy="IsBusy">
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner v-if="isBusy" class="align-middle" type="grow"></b-spinner>
                    <i v-else class="fs-5 mdi mdi-cancel"></i>
                    <strong>{{ isBusy ? 'Fetching Data...' : 'No Data Found' }}</strong>
                  </div>
                </template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <!-- <template #cell(memberid)="data">
                    <b class="text-info">{{ data.item.member.member_id }}</b>
                  </template> -->
                <template #cell(member)="data">
                  <router-link :to="{
                    path: '/memberprofile',
                    query: { id: data.item.member.member_id },
                  }">
                    <span @mouseover="name_hover = true; current_index = data.index" @mouseout="name_hover = false">
                      <span
                        :class="(name_hover && current_index == data.index) ? 'fw-bold text-dark text-decoration-underline' : 'text-dark'">{{
                          data.item.member.name }}</span>
                      <span class="d-block text-info fw-bold">{{ data.item.member.member_id
                        }}</span>
                    </span>
                  </router-link>
                </template>

                <template #cell(loan_type)="data">
                  <b><span class="text-info">{{ data.item.loan_type.name }}</span> <br>
                    <small>{{ data.item.loan_type.rate }}%</small> &nbsp;&nbsp;&nbsp;
                    <small>{{ data.item.loan_type.period }}days</small></b>
                </template>
                <template #cell(amount)="data">
                  {{ commas(data.item.amount) }}
                </template>
                <template #cell(charges)="data">
                  {{ commas(data.item.charges) }}
                </template>
                <template #cell(interest)="data">
                  {{ commas(data.item.interest) }}
                </template>
                <template #cell(payback)="data">
                  {{ commas(data.item.payback) }}
                  <small class="d-block text-info fw-bold mt-1">{{ commas(data.item.repaymentplan) }}
                    /{{
                      data.item.repaymentstructure }}</small>
                </template>
                <template #cell(repaymentplan)="data">
                  {{ commas(data.item.repaymentplan) }} /{{ data.item.repaymentstructure }}
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                    <!-- <b-button @click.prevent="editLoanApplicationModal(data.item.id,
                      data.item.member,
                      data.item.loan_type,
                      data.item.amount,
                      data.item.charges,
                      data.item.interest,
                      data.item.payback,
                      data.item.repaymentstructure,
                      data.item.repaymentplan,
                      data.item.applicationdate,
                      data.item.guarantor,
                      data.item.guarantor2,
                      data.item.guarantor3,
                      data.item.security)" v-show="userData.permissions['new_loanapplications'] == 1" type="button"
                      class="btn-sm" variant="primary" title="Edit"><i class="mdi mdi-pen"></i></b-button> -->
                    <b-button v-show="userData.permissions['approve_loanapplications'] == 1"
                      @click="approve(data.item.id, data.item.member, data.item.amount, data.item.interest, data.item.payback, data.item.applicationdate)"
                      type="button" class="btn-sm" variant="info" title="Approve" v-b-modal.edit><i
                        class="mdi mdi-checkbox-marked-outline"></i></b-button>
                    <b-button v-show="userData.permissions['delete_loanapplications'] == 1"
                      @click="remove(data.item.id, data.item.member.name)" type="button" class="btn-sm btn"
                      variant="danger" v-b-modal.delete title="Decline"> <i class="mdi mdi-close"></i> </b-button>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <b>Total Loans : {{ commas(totalloan) }}</b>
              </div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to Application</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-application" :size="modalSize" hide-header hide-footer>
      <form>
        <div v-if="!member" class="container text-center">
          <div><i class="mdi mdi-bank text-primary" style="font-size: 50px;"></i></div>
          <span class="fs-4">New Loan Application</span>
          <small class="d-block fw-bold">With<span v-if="!useCreditScore">out</span> Credit Scoring</small>
          <br>

          <span class="d-block text-primary">Members get Loan Limits according to their Credit Scores. <br>
            The Credit
            Score depends on the Member's Saving, Loan and Withdraw Activity.</span>
          <hr>
          <div class="form-group">
            <v-select :options="members" required placeholder="Select Member" v-model="member" label="name"
              @input="FindBalance()"></v-select>
          </div>
          <div class="text-end mt-3 mb-0">
            <b-button type="button" class="btn" variant="secondary"
              @click="$bvModal.hide('new-application')">Close</b-button>
          </div>
        </div>

        <div v-else class="row mb-0">
          <div class="col-1 text-end px-0"><i class="mdi mdi-bank text-primary" style="font-size: 30px;"></i>
          </div>
          <div class="col">
            <span class="fs-4">Loan Applications</span>
            <small style="margin-top: -4px;" class="d-block fw-bold">With<span v-if="!useCreditScore">out</span> Credit
              Scoring</small>
          </div>
          <div class="col">
            <div class="d-flex align-items-center">
              <input type="checkbox" v-model="useCreditScore" class="form-check me-1" /> <span class="fs-5">Credit
                Scoring</span>
            </div>
            <small style="margin-top: -3px;" class="d-block fw-bold">Enable or Disable Credit Scoring</small>
          </div>
          <div class="col text-end">
            <b-button type="button" class="btn ms-2" variant="secondary"
              @click="$bvModal.hide('new-application')">Close</b-button>
          </div>
          <hr>
        </div>

        <div v-if="member" class="container mb-0">
          <div class="fs-4 text-center mb-0">
            {{ member.name }} <b style="font-size: 12px;">{{ member.member_id }} </b> <span class="mdi mdi-close-thick text-danger" type="button"
              @click="member = ''; savingbalance = ''; loanlimit = '';" title="Unselect Member"></span>
          </div>

          <div class="row">
            <div class="col text-center">
              <!-- <span v-if="useCreditScore" class="fs-5 text-info fw-bold">{{ Math.round(credit_score * 10000) / 100
              }}%</span> -->
              <span v-if="useCreditScore" class="fs-5 text-info fw-bold">
                <i @click="createCreditReport" type="button"
                  class="bg-primary text-white px-2 py-1 rounded mdi mdi-plus fs-6 me-2"></i>
                <span @click="goToCreditReport" style="cursor: pointer;">{{ credit_score }}% | {{ credit_score_points }}
                  points</span>
              </span>
              <span v-else class="fs-5 text-info fw-bold">-</span>
              <small class="d-block fw-bold">Latest Credit Report</small>
            </div>
            <div class="col text-center">
              <span class="fs-5 text-info fw-bold">{{ commas(savingbalance || 0) }}/=</span>
              <small class="d-block fw-bold">Standing Balance</small>
            </div>
            <div class="col text-center">
              <span class="fs-5 text-info fw-bold">{{ commas(loanstaken || 0) }} loan(s)</span>
              <small class="d-block fw-bold">Loans taken before</small>
            </div>
            <div class="col text-center">
              <span class="fs-5 text-info fw-bold">{{ commas(loanlimit || 0) }}/=</span>
              <small class="d-block fw-bold"><span v-if="useCreditScore">Recommended</span> Loan Limit</small>
            </div>
          </div>
          <hr>
        </div>

        <div v-if="member" class="row">
          <h5 class="text-primary fw-bold mb-0">Loan Details</h5>
          <div class="col-8">
            <div class="row">
              <div class="form-group col-6">
                <label class="mb-0 mt-2">Loan Type</label> <small class="text-danger">*</small>
                <v-select :options="loantypes" placeholder="Select an Option" v-model="loantype" label="name"
                  :reduce="loantype => loantype.id" @input="FindRate();"></v-select>
              </div>
              <div class="form-group col-6">
                <div class="row">
                  <div class="col-6"><label class="mb-0 mt-2">Period:</label>
                    <div class="mt-1 fs-5 fw-bold text-danger">{{ loan_period ? `${loan_period} days` : '-' }}</div>
                  </div>
                  <div class="col-6"><label class="mb-0 mt-2">Monthly Rate:</label>
                    <div class="mt-1 fs-5 fw-bold text-primary">{{ loan_rate ? `${loan_rate}%` : '-' }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-6">
                <label class="mb-0 mt-2">Loan Amount</label> <small class="text-danger">*</small>
                <input id="numberInput" v-model="amount" required placeholder="Loan Amount"
                  @input="amount = onFocus(amount); FindCharge()" @focus="amount = onFocus(amount)" type="text"
                  class="form-control" />
              </div>

              <!-- Other SACCOs -->
              <div v-if="userData.member.business != 5" class="form-group col-6">
                <div class="row">
                  <div class="col-6"><label class="mb-0 mt-2">Charges:</label>
                    <div class="mt-1 fs-5 fw-bold text-danger">{{ charges ? `${commas(charges)}/=` : '-' }}</div>
                  </div>
                  <div class="col-6"><label class="mb-0 mt-2">Interest:</label>
                    <div class="mt-1 fs-5 fw-bold text-primary">{{ interest ? `${commas(interest)}/=` : '-' }}</div>
                  </div>
                </div>
              </div>

              <!-- Ganesh SACCOs -->
              <div v-else class="form-group col-4">
                <label class="mb-0 mt-2">Charges <i class="px-1 m-0 mdi mdi-help"
                    style="background-color: gainsboro; border-radius: 100%;" @mouseover="charges_tooltip = true"
                    @mouseout="charges_tooltip = false;"></i></label>
                <small v-if="charges_tooltip" class="d-block p-2 bg-white text-dark"
                  style="position: absolute; z-index: 100;">2% charges that reflect as savings</small>
                <input v-model="charges" readonly placeholder="Charges" class="form-control" />
              </div>
            </div>

            <div class="row">

              <div class="form-group col-6">
                <label class="mb-0 mt-2">Repayment Structure</label>
                <v-select :options="paymentstructures" @input="FindPlan()" placeholder="Select an Option"
                  v-model="repaymentstructure" label="description"
                  :reduce="repaymentstructure => repaymentstructure.name"></v-select>
              </div>

              <!-- <div class="form-group col-6">
                <label class="mb-0 mt-2">PayBack</label>
                <input v-model="payback" readonly placeholder="Payback" class="form-control" />
              </div> -->

              <div class="form-group col-6">
                <label class="mb-0 mt-2">Repayment Plan:</label>
                <!-- <input v-model="repaymentplan" readonly placeholder="Payment Plan" class="form-control" /> -->
                <div class="mt-1 fs-5 fw-bold text-primary">{{ repaymentplan ? `${commas(repaymentplan)}/= per
                  ${repaymentstructure}` : '-' }}</div>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="container bg-white shadow-lg rounded pt-2 pb-1" style="margin-top: -25px;">
              <h6 class="text-danger border-bottom">Issues</h6>
              <ul id="issues" class="list-unstyled" style="height: 145px; overflow-y: auto;">
                <li v-for="issue in issues" :key="issue"><small>{{ issue }}</small></li>
              </ul>
            </div>
          </div>

          <div>
            <hr>
            <h5 class="text-primary fw-bold mb-0">Loan Security</h5>
            <div class="row">
              <div class="form-group col-4">
                <label class="mb-0 mt-2">Purpose for the loan</label>
                <input v-model="loanpurpose" type="text" placeholder="Loan Purpose" class="form-control" />
              </div>
              <div class="form-group col-4">
                <label class="mb-0 mt-2">Source of Income</label>
                <input v-model="sourceofincome" type="text" placeholder="Source of Income" class="form-control" />
              </div>
              <div class="form-group col-4">
                <label class="mb-0 mt-2">Source of Income Description</label>
                <input v-model="sourceofincomedescription" type="text" placeholder="Source of Income Description" class="form-control" />
              </div>
              </div>
            <div class="row" v-show="this.userData.settings.security == 2 || this.userData.settings.security == 3">
              <div class="form-group col-4">
                <label class="mb-0 mt-2">Guarantor 1</label> <small class="text-danger">*</small>
                <v-select :options="members" placeholder="Select an Option" v-model="guarantor" @input="FindGuarantor()"
                  label="name" :reduce="member => member.member_id"></v-select>
                <b class="text-danger mt-2" v-html=" guarantorError"></b>
              </div>
              <div class="form-group col-4" v-if="userData.settings.no_of_guarantors > 1">
                <label class="mb-0 mt-2">Guarantor 2</label> <small class="text-danger">*</small>
                <v-select :options="members" placeholder="Select an Option" v-model="guarantor2"
                  @input="FindGuarantor2()" label="name" :reduce="member => member.member_id"></v-select>
                <b class="text-danger mt-2" v-html="guarantor2Error"></b>
              </div>
              <div class="form-group col-4" v-if="userData.settings.no_of_guarantors > 2">
                <label class="mb-0 mt-2">Guarantor 3</label> <small class="text-danger">*</small>
                <v-select :options="members" placeholder="Select an Option" v-model="guarantor3"
                  @input="FindGuarantor3()" label="name" :reduce="member => member.member_id"></v-select>
                <b class="text-danger mt-2" v-html="guarantor3Error"></b>
              </div>
              <div class="form-group col-12"
                v-show="this.userData.settings.security == 1 || this.userData.settings.security == 3">
                <label class="mb-0 mt-2">Collateral Security</label>
                <textarea v-model="security" rows="2" placeholder="Security" class="form-control"></textarea>
              </div>
            </div>
          </div>
        </div>

        <!-- <small class="text-danger">{{ chargesError }}</small> <br>
        <small class="text-danger">{{ chargesError1 }}</small> -->

        <div v-if="member" class="form-group d-flex justify-content-end align-items-end">
          <div class="me-2 w-25">
            <label class="mb-0">Application Date</label>
            <input required v-model="application_date" :max="currentdate" type="date" class="form-control" />
          </div>
          <div class="">
            <b-button @click="disburse = false; addLoanApplication()" :disabled="loanApplicationRequired"
              class="btn ms-2" variant="outline-primary"><i class="fas fa-check-circle"></i> Submit</b-button>
          </div>
          <div class="">
            <b-button @click="disburse = true; addLoanApplication()" :disabled="loanApplicationRequired"
              class="btn ms-2" variant="primary"><i class="fas fa-check-circle"></i> Submit & Approve</b-button>
          </div>
        </div>
      </form>
    </b-modal>

    <b-modal id="edit-application" size="xl" centered title="Edit Loan Application" title-class="font-18" hide-footer>
      <form @submit.prevent="editLoanApplication">
        <div class="row">
          <div class="form-group col-4">
            <label class="mb-0 mt-2">Member</label> <small class="text-danger">*</small>
            <v-select :options="members" required placeholder="Select an Option" v-model="member" label="name"
              :reduce="member => member.member_id" disabled></v-select>
          </div>
          <div class="form-group col-4">
            <label class="mb-0 mt-2">Standing Balance</label>
            <input v-model="savingbalance" type="text" placeholder="Standing Balance" readonly class="form-control" />
          </div>
          <div class="form-group col-4">
            <label class="mb-0 mt-2">Loan Limit</label>
            <input v-model="loanlimit" type="text" placeholder="Loan Limit" disabled class="form-control" />
          </div>
          <div class="form-group col-4">
            <label class="mb-0 mt-2">Loan Type</label> <small class="text-danger">*</small>
            <v-select :options="loantypes" required placeholder="Select an Option" v-model="loantype" label="name"
              :reduce="loantype => loantype.id" @input="FindRate()" disabled></v-select>
          </div>
          <div class="form-group col-4">
            <label class="mb-0 mt-2">Period</label> <small class="text-danger">(days)</small>
            <input v-model="loan_period" type="text" placeholder="Period" disabled class="form-control" />
          </div>
          <div class="form-group col-4">
            <label class="mb-0 mt-2">Monthly Rate</label> <small class="text-danger">(%)</small>
            <input v-model="loan_rate" type="text" placeholder="Rate" disabled class="form-control" />
          </div>
          <div class="form-group col-4">
            <label class="mb-0 mt-2">Loan Amount</label> <small class="text-danger">*</small>
            <input v-model="amount" required placeholder="Loan Amount" @input="checkLoanAmount(); FindCharge()"
              type="number" class="form-control" disabled />
          </div>
          <div class="form-group col-4">
            <label class="mb-0 mt-2">Charges</label>
            <input v-model="charges" disabled placeholder="Charges" class="form-control" />
          </div>
          <div class="form-group col-4">
            <label class="mb-0 mt-2">Interest</label>
            <input v-model="interest" type="number" placeholder="Interest" class="form-control" @input="FindCharge2" />
          </div>
          <div class="form-group col-4">
            <label class="mb-0 mt-2">PayBack</label>
            <input v-model="payback" disabled placeholder="Payback" class="form-control" />
          </div>
          <div class="form-group col-4">
            <label class="mb-0 mt-2">Repayment Structure</label>
            <v-select :options="paymentstructures" required @input="FindPlan()" placeholder="Select an Option"
              v-model="repaymentstructure" label="description" :reduce="repaymentstructure => repaymentstructure.name"
              disabled></v-select>
          </div>
          <div class="form-group col-4">
            <label class="mb-0 mt-2">Repayment Plan</label>
            <input v-model="repaymentplan" disabled placeholder="Payment Plan" class="form-control" />
          </div>
          <div class="row" v-show="this.userData.settings.security == 2 || this.userData.settings.security == 3">
            <div class="form-group col-4">
              <label class="mb-0 mt-2">Guarantor 1</label> <small class="text-danger">*</small>
              <v-select :options="members" placeholder="Select an Option" v-model="guarantor" @input="FindGuarantor()"
                label="name" :reduce="member => member.member_id"></v-select>
              <small class="text-danger">{{ guarantorError }}</small>
            </div>
            <div class="form-group col-4" v-if="userData.settings.no_of_guarantors > 1">
              <label class="mb-0 mt-2">Guarantor 2</label> <small class="text-danger">*</small>
              <v-select :options="members" placeholder="Select an Option" v-model="guarantor2" @input="FindGuarantor2()"
                label="name" :reduce="member => member.member_id"></v-select>
              <small class="text-danger">{{ guarantor2Error }}</small>
            </div>
            <div class="form-group col-4" v-if="userData.settings.no_of_guarantors > 2">
              <label class="mb-0 mt-2">Guarantor 3</label> <small class="text-danger">*</small>
              <v-select :options="members" placeholder="Select an Option" v-model="guarantor3" @input="FindGuarantor3()"
                label="name" :reduce="member => member.member_id"></v-select>
              <small class="text-danger">{{ guarantor3Error }}</small>
            </div>
          </div>
          <div class="form-group col-4">
            <label class="mb-0 mt-2">Application Date</label>
            <input v-model="application_date" :max="currentdate" type="date" class="form-control" />
          </div>

          <div class="form-group col-8"
            v-show="this.userData.settings.security == 1 || this.userData.settings.security == 3">
            <label class="mb-0 mt-2">Security</label>
            <textarea v-model="security" rows="2" placeholder="Security" class="form-control"></textarea>
          </div>
        </div>

        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('edit-application')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary">
            <span v-if="loan_application_loader"><b-spinner small></b-spinner></span>
            <span v-else><i class="fas fa-check-circle"></i> Submit</span>
          </b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="approve-application" centered title="Are you sure you want to Approve Loan Application"
      title-class="font-14" hide-footer>
      <form @submit.prevent="approveLoanApplication">
        <div class="form-group mb-2">
          <label>Member : </label>
          <h5><span class="text-info h5" v-html="member"></span> - <span class="text-info h5"
              v-html="membername"></span>
          </h5>
        </div>
        <div class="form-group mb-2">
          <label>Loan Amount</label>
          <h5 class="text-info" v-html="commas(amount)"></h5>
        </div>
        <div class="form-group mb-2">
          <label>Interest</label>
          <h5 class="text-info" v-html="commas(interest)"></h5>
        </div>
        <div class="form-group mb-2">
          <label>Payback</label>
          <h5 class="text-info" v-html="commas(payback)"></h5>
        </div>
        <div class="form-group mb-2">
          <label>Application Date</label>
          <h5 class="text-info" v-html="application_date"></h5>
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('approve-application')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            Submit</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="delete-application" centered title="Decline Loan Application" title-class="font-18" hide-footer>
      <form @submit.prevent="removeLoanApplication">
        <input v-model="id" type="hidden">
        Are you sure you want to decline the Loan Application for : <b>{{ membername }}</b> ?
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('delete-application')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            YES</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="errors" title="Errors" centered title-class="font-18" hide-footer>
      <div class="text-danger">{{ errors }}</div>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { formatNumber, removeCommas } from '@/numberUtils';
import { loanapplicationMethods, loanapplicationComputed, memberMethods, memberComputed, loantypeMethods, loantypeComputed } from "@/state/helpers";

export default {
  page: {
    title: "Loan Application",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  components: {
    Layout, PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Loan Application",
      items: [{ text: "Dashboard", to: "/", }, { text: "Loan Application", active: true, },],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      paymentstructures: [
        { name: 'day', description: 'Daily' },
        { name: 'week', description: 'Weekly' },
        { name: 'month', description: 'Monthly' },
      ],
      fields: [
        { key: 'index', label: '#', visible: true },
        { key: 'id', label: 'ID', visible: false },
        // { key: 'memberid', label: 'Member ID', visible: true },
        { key: 'member', label: 'Name', visible: true },
        { key: 'loan_type', label: 'Loan Product', visible: true },
        { key: 'amount', label: 'Amount', visible: true },
        { key: 'charges', label: 'Charges', visible: true },

        { key: 'interest', label: 'Interest', visible: true },
        { key: 'payback', label: 'Payback', visible: true },
        // { key: 'repaymentplan', label: 'Repayment Plan', visible: true },
        { key: 'applicationdate', label: 'Application Date', visible: true },
        { key: 'actions', label: 'Actions', visible: true },
      ],

      id: '',
      member: '',
      amount: '',
      charges: '',
      application_date: new Date().toLocaleDateString('fr-CA'),
      membername: '',
      payback: '',
      rate: '',
      period: '',
      loan_rate: '',
      loan_period: '',
      loantype: '',
      interest: '',
      repaymentstructure: 'day',
      repaymentplan: '',
      guarantor: '',
      guarantor2: '',
      guarantor3: '',
      guarantorError: '', guarantor2Error: '', guarantor3Error: '',
      security: '',
      saveBtn: false,
      saveError: '',
      chargesError1: '',
      chargesError: '',
      savingbalance: '',
      loanstaken: '',
      currentdate: new Date().toLocaleDateString('fr-CA'),
      date_to: new Date().toLocaleDateString('fr-CA'),
      date_from: new Date().toLocaleDateString('fr-CA'),
      loader: false,
      progress: 0,
      import_file: '',
      errors: '',
      uploading: false,
      loan_application_loader: false,
      charges_tooltip: false,
      name_hover: false,
      current_index: '',
      useCreditScore: true,
      issues: [],
      disburse: false,
      credit_report: [],
      loanpurpose: '', sourceofincome: '', sourceofincomedescription: '',
    };
  },
  computed: {
    ...loanapplicationComputed,
    ...memberComputed,
    ...loantypeComputed,
    List() { return this.loanapplications.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.loanapplications.map((d) => ({ ...d })) },
    IsBusy() { let a = false; if (this.loanapplications.length > 0) { a = false; } else { a = true; } return a },
    totalloan() { var total = 0; this.loanapplications.forEach((item) => { var item_total = item.amount; total = Number(total) + Number(item_total); }); return total },
    credit_score() {
      if (this.credit_report) {
        let total = Number(this.credit_report.loan_repayment) + Number(this.credit_report.saving_history) + Number(this.credit_report.character) + Number(this.credit_report.repayment_capacity) + Number(this.credit_report.membership) + Number(this.credit_report.meeting_attendance) + Number(this.credit_report.purpose) + Number(this.credit_report.bank_statements);
        let clampedTotal = Math.min(Math.max(total, 0), 100);
        return Math.floor(clampedTotal);
      }
      return 0;
    },
    credit_score_points() {
      if (this.credit_report) {
        let scaledValue = 300 + ((this.credit_score - 0) * (850 - 300)) / (100 - 0);
        return scaledValue;
      }
      return 300;
    },
    modalSize() { return this.member ? 'xl' : '' },
    loanlimit() {
      if (this.useCreditScore) {
        let percentage = 0.3;

        if (this.credit_score_points >= 300 && this.credit_score_points <= 528) {
          percentage = 0.3;
        } else if (this.credit_score_points >= 529 && this.credit_score_points <= 650) {
          percentage = 0.5;
        } else if (this.credit_score_points >= 651 && this.credit_score_points <= 696) {
          percentage = 0.7;
        } else if (this.credit_score_points >= 697 && this.credit_score_points <= 717) {
          percentage = 0.9;
        } else if (this.credit_score_points >= 718 && this.credit_score_points <= 743) {
          percentage = 1.0;
        } else if (this.credit_score_points >= 744 && this.credit_score_points <= 850) {
          percentage = 1.2;
        }
        return this.savingbalance * this.userData.settings.loanlimit * percentage;
      }
      return this.savingbalance * this.userData.settings.loanlimit
    },
    loanApplicationRequired() {
      return !this.member || !this.amount || !this.loantype || !this.application_date || !this.repaymentstructure;
    }
  },

  watch: {
    member(newValue) {
      if (this.useCreditScore && newValue && newValue != null) {
        axios.get(`latest-credit-report/${newValue.member_id}`).then((response) => {
          this.credit_report = response.data.report;
        });
      }
    },

    useCreditScore(newValue) {
      if (newValue) {
        axios.get(`latest-credit-report/${this.member.member_id}`).then((response) => {
          this.credit_report = response.data.report;
        });
      }
    }
  },

  async mounted() {
    if (this.$route.params.member) {
      this.member = this.$route.params.member;
      this.$bvModal.show('new-application'); // Show modal when event is triggered
      this.FindBalance()
    }
    this.fetchMembers();
    this.fetchLoanTypes();
    await this.fetchLoanApplications();
    this.TotalRows = this.loanapplications.length;
    this.isBusy = false;
  },
  methods: {
    ...loanapplicationMethods,
    ...memberMethods,
    ...loantypeMethods,
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    onBlur(field) {
      return removeCommas(field);
    },

    onFocus(field) {
      return formatNumber(field);
    },

    clearFields() {
      this.disburse = false;
      this.member = '';
      this.amount = '';
      this.charges = '';
      this.application_date = new Date().toLocaleDateString('fr-CA');
      this.membername = '';
      this.payback = '';
      this.rate = '';
      this.period = '';
      this.loan_rate = '';
      this.loan_period = '';
      this.loantype = '';
      this.interest = '';
      this.repaymentstructure = 'day';
      this.repaymentplan = '';
      this.guarantor = '';
      this.guarantor2 = '';
      this.guarantor3 = '';
      this.security = '';
      this.savingbalance = '';
      this.loanstaken = '';
      this.loanpurpose = '';
      this.sourceofincome = '';
      this.sourceofincomedescription = '';
      this.currentdate = new Date().toLocaleDateString('fr-CA');
    },

    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },

    checkLoanAmount() {
      this.amount = this.onBlur(this.amount)
      if (this.amount > this.loanlimit) {
        this.amount = this.loanlimit; // Adjust the amount to be within loan limit
      }
    },

   async FindGuarantor() {
      this.guarantorError = "";
      if (this.guarantor) {
        if (this.guarantor === this.member.member_id) {
          this.guarantorError = "A member cannot be their own guarantor.";
          return;
        }

        if (this.guarantor === this.guarantor2 || this.guarantor === this.guarantor3) {
          this.guarantorError = "Member Already Chosen";
          return;
        }

        const response = await axios.get(`/guarantor-check/${this.guarantor}`);
        const data = response.data;

        if (data.alreadyGuarantor) {
          this.guarantorError = `Already guarantor for ${data.loanMember}`;
        }else {
          this.guarantorError = `<b style="color:blue;">Saving Balance: UGX ${data.savingBalance.toLocaleString()}</b>`;
        }

      }
    },

    async FindGuarantor2() {
      this.guarantor2Error = "";
      if (this.guarantor2) {
        if (this.guarantor2 === this.member.member_id) {
          this.guarantor2Error = "A member cannot be their own guarantor.";
          return;
        }

        if (this.guarantor2 === this.guarantor || this.guarantor2 === this.guarantor3) {
          this.guarantor2Error = "Member Already Chosen";
          return;
        }

        const response = await axios.get(`/guarantor-check/${this.guarantor2}`);
        const data = response.data;

        if (data.alreadyGuarantor) {
          this.guarantor2Error = `Already guarantor for ${data.loanMember}`;
        } else {
          this.guarantor2Error = `<b style="color:blue;">Saving Balance: UGX ${data.savingBalance.toLocaleString()}</b>`;
        }
      }
    },

    async FindGuarantor3() {
      this.guarantor3Error = "";
      if (this.guarantor3) {
        if (this.guarantor3 === this.member.member_id) {
          this.guarantor3Error = "A member cannot be their own guarantor.";
          return;
        }

        if (this.guarantor3 === this.guarantor || this.guarantor3 === this.guarantor2) {
          this.guarantor3Error = "Member Already Chosen";
          return;
        }

        const response = await axios.get(`/guarantor-check/${this.guarantor3}`);
        const data = response.data;

        if (data.alreadyGuarantor) {
          this.guarantor3Error = `Already guarantor for ${data.loanMember}`;
        }else {
          this.guarantor3Error = `<b style="color:blue;">Saving Balance: UGX ${data.savingBalance.toLocaleString()}</b>`;
        }
      }
    },


    async FindBalance() {
      let url = `/savingsbalance/${this.member.member_id}`;
      await axios.get(url).then((response) => {
        this.savingbalance = response.data.balance;
        this.loanstaken = response.data.loanstaken;
        this.chargesError1 = response.data.error;
        this.issues = response.data.issues
      });
    },
    async FindRate() {
      let url = `/findloanrate/${this.loantype}`;
      await axios.get(url).then((response) => {
        this.loan_period = response.data.period;
        this.loan_rate = response.data.rate;
        this.FindCharge();
      });
    },

    async FindCharge() {
      this.interest = Math.ceil(removeCommas(this.amount) * (this.loan_rate / 100) * this.loan_period / 30);
      this.payback = (Number(removeCommas(this.amount))) + Number(this.interest);
      if (this.repaymentstructure == 'month') {
        this.repaymentplan = Math.ceil((this.payback) / (this.loan_period / 30));
      }
      else if (this.repaymentstructure == 'week') {
        this.repaymentplan = Math.ceil((this.payback) / (this.loan_period / 7));
      }
      else if (this.repaymentstructure == 'day') {
        this.repaymentplan = Math.ceil((this.payback) / this.loan_period);
      }
      else {
        this.repaymentplan = Math.ceil((this.payback) / (this.loan_period));
      }

      let formData = new FormData();
      formData.append("member", this.member);
      formData.append("amount", removeCommas(this.amount));
      formData.append('loan_limit', this.loanlimit)
      let url = "/findloancharges";
      if (this.amount) {
        await axios.post(url, formData).then((response) => {
          if (response.status == 200) {
            this.charges = response.data.charges;
            this.chargesError = response.data.error;
          }
        });
      }
    },

    async FindCharge2() {
      this.payback = Number(removeCommas(this.amount)) + Number(this.interest);
      if (this.repaymentstructure == 'month') {
        this.repaymentplan = Math.ceil((this.payback) / (this.loan_period / 30));
      }
      else if (this.repaymentstructure == 'week') {
        this.repaymentplan = Math.ceil((this.payback) / (this.loan_period / 7));
      }
      else if (this.repaymentstructure == 'day') {
        this.repaymentplan = Math.ceil((this.payback) / this.loan_period);
      }
      else {
        this.repaymentplan = Math.ceil((this.payback) / (this.loan_period));
      }

      let formData = new FormData();
      formData.append("member", this.member);
      formData.append("amount", removeCommas(this.amount));
      formData.append('loan_limit', this.loanlimit)
      let url = "/findloancharges";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.charges = response.data.charges;
          this.chargesError = response.data.error;
        }
      });
    },

    FindPlan() {
      if (this.repaymentstructure == 'month') {
        this.repaymentplan = Math.ceil(this.payback / Number(this.loan_period / 30));
      }
      else if (this.repaymentstructure == 'week') {
        this.repaymentplan = Math.ceil(this.payback / Number(this.loan_period / 7));
      }
      else if (this.repaymentstructure == 'day') {
        this.repaymentplan = Math.ceil(this.payback / this.loan_period);
      }
    },

    async addLoanApplication() {
      this.saveBtn = true;
      this.saveError = "Saving Loan Application";
      let formData = new FormData();
      if (this.disburse) {
        formData.append("status", 2);
        formData.append('disbursement_date', this.application_date)
      }
      formData.append("member", this.member.member_id);
      formData.append("loan_type", this.loantype);
      formData.append("amount", removeCommas(this.amount));
      formData.append("charges", this.charges);
      formData.append("interest", this.interest);
      formData.append("payback", this.payback);
      formData.append("repaymentstructure", this.repaymentstructure);
      formData.append("repaymentplan", this.repaymentplan);
      formData.append("applicationdate", this.application_date);
      formData.append("guarantor", this.guarantor);
      formData.append("guarantor2", this.guarantor2);
      formData.append("guarantor3", this.guarantor3);
      formData.append("security", this.security);
      if (this.useCreditScore && !this.credit_report) {
        formData.append('credit_report', this.credit_report.id)
      }
      formData.append("loanpurpose", this.loanpurpose);
      formData.append("sourceofincome", this.sourceofincome);
      formData.append("sourceofincomedescription", this.sourceofincomedescription);
      let url = "/addloanapplication";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchLoanApplications();
          this.$bvModal.hide('new-application');
          if (this.disburse) {
            this.$toast.info("New Loan Application Added & Approved");
          } else {
            this.$toast.info("New Loan Application Added");
          }
          this.saveBtn = false;
          this.saveError = "";
          this.clearFields();
        }
      });
    },

    editLoanApplicationModal(id, member, loan_type, amount, charges, interest, payback, repaymentstructure, repaymentplan, applicationdate, guarantor, guarantor2, guarantor3, security) {
      this.id = id
      this.member = member.member_id;
      this.loantype = loan_type.id;
      this.amount = amount;
      this.charges = charges;
      this.interest = interest;
      this.payback = payback;
      this.repaymentstructure = repaymentstructure;
      this.repaymentplan = repaymentplan;
      this.application_date = applicationdate;
      this.guarantor = guarantor.member_id;
      this.guarantor2 = guarantor2.member_id;
      this.guarantor3 = guarantor3.member_id;
      this.security = security;
      this.$bvModal.show('edit-application')
      this.FindBalance()
      this.FindRate()

    },

    async editLoanApplication() {
      this.loan_application_loader = true
      let obj = {
        id: this.id,
        member: this.member,
        interest: this.interest,
        guarantor: this.guarantor,
        guarantor2: this.guarantor2,
        guarantor3: this.guarantor3,
        security: this.security
      };

      let url = "/edit-loan-application";
      await axios.post(url, obj)
        .then((response) => {
          if (response.status === 200) {
            this.fetchLoanApplications();
            this.$bvModal.hide('edit-application');
            this.$toast.success("Loan Application Updated");
            this.loan_application_loader = false
          }
        })
        .catch((error) => {
          this.$toast.error(error);
          this.loan_application_loader = false
        });
    },

    approve(id, member, amount, interest, payback, applicationdate) {
      this.id = id;
      this.member = member.member_id;
      this.membername = member.name;
      this.amount = amount;
      this.interest = interest;
      this.payback = payback;
      this.application_date = applicationdate;
      this.$bvModal.show('approve-application')
    },
    remove(id, member) {
      this.id = id;
      this.membername = member;
      this.$bvModal.show('delete-application')
    },
    async approveLoanApplication() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/approveloanapplication";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchLoanApplications();
          this.$bvModal.hide('approve-application');
        }
      });
    },
    async removeLoanApplication() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removeloanapplication";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchLoanApplications();
          this.$bvModal.hide('delete-application');
        }
      });
    },

    goToCreditReport() {
      this.$router.push({ name: 'credit-reports', params: { credit_report: this.credit_report.id } });
    },

    createCreditReport() {
      this.$router.push({ name: 'credit-form', params: { member: this.member } });
    },

    FilterData() {
      this.filterLoanApplications({ datefrom: this.date_from, dateto: this.date_to });
    },
  }
};
</script>

<style>
.progress {
  width: 100%;
  height: 30px;
  background-color: #f3f3f3;
  border-radius: 5px;
  overflow: hidden;
}

.progress-bar {
  height: 100%;
  background-color: #4caf50;
  text-align: center;
  color: white;
  transition: width 0.4s ease;
}

#issues {
  list-style: none;
  /* Remove default bullets */
  padding-left: 0;
}

#issues li::before {
  content: "🚫";
  /* Custom bullet (emoji or Unicode) */
  color: green;
  font-size: 10px;
  margin-right: 10px;
}
</style>